import BasePopper from '@material-ui/core/Popper'

const Popper = BasePopper

export default Popper
